import { PatientDetailsRoute } from './PatientRoutes';

export const calcPatientDetailRoute = (id: string) => PatientDetailsRoute.replace(':id', id);
